import { LangCode } from "./types";

export const changeLanguage = (langCode: LangCode) =>
  `api/UserAccount/Locale/${langCode}`;

export const getLanguage = () => `api/UserAccount/Locale`;
